var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { LoginError } from "../../types";
import { PlatformLoginError } from "../../Platform";
export const makeTokenRequest = (ajaxService, tokenRequestParameters) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield ajaxService.send(tokenRequestParameters.url, tokenRequestParameters.options);
    const responseText = yield response.text();
    if (response.status < 200 || response.status > 299) {
        const responseData = getErrorResponse(responseText);
        if (isPlatformError(responseData)) {
            throw new PlatformLoginError(responseData);
        }
        const message = getErrorMessage(responseData, response);
        throw new LoginError(message, responseData);
    }
    return tokenRequestParameters.parser(responseText);
});
const getErrorResponse = (responseText) => {
    if (responseText) {
        try {
            return JSON.parse(responseText);
        }
        catch (e) {
            console.warn(e);
        }
    }
};
const getErrorMessage = (responseData, response) => {
    return (responseData && (responseData.message || responseData.Message)) || response.statusText;
};
const isPlatformError = (responseData) => {
    return responseData && responseData.code;
};
//# sourceMappingURL=makeTokenRequest.js.map